
export const Booking = () => {
    return (
        <div>Booking</div>
    )
}
